<template>
    <div class="container-fluid">
        <form
            class="form"
            @submit.prevent="createCustomer()"
        >
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <div class="card">
                        <div class="card-body">
                            <h4>Customer details</h4>

                            <div class="form-group">
                                <label for="company_name">Company name:</label>
                                <input
                                    id="company_name"
                                    v-model="customer.company_name"
                                    type="text"
                                    placeholder="Company name"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.company_name }"
                                >
                                <error
                                    name="company_name"
                                    :errors="errors"
                                />
                            </div>

                            <div class="form-group">
                                <label for="account_ref">Account reference:</label>
                                <input
                                    id="account_ref"
                                    v-model="customer.account_ref"
                                    type="text"
                                    placeholder="Account ref."
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.account_ref }"
                                >
                                <error
                                    name="account_ref"
                                    :errors="errors"
                                />
                            </div>

                            <div class="form-group">
                                <label for="billing_name">Billing contact name:</label>
                                <input
                                    id="billing_name"
                                    v-model="customer.billing_name"
                                    type="text"
                                    placeholder="Billing contact name"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.billing_name }"
                                >
                                <error
                                    name="billing_name"
                                    :errors="errors"
                                />
                            </div>

                            <div class="row">
                                <div class="form-group col-sm-6">
                                    <label for="billing_email">Billing email:</label>
                                    <input
                                        id="billing_email"
                                        v-model="customer.billing_email"
                                        type="email"
                                        placeholder="Billing email"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.billing_email }"
                                    >
                                    <error
                                        name="billing_email"
                                        :errors="errors"
                                    />
                                </div>
                                <div class="form-group col-sm-6">
                                    <label for="billing_telephone">Billing telephone:</label>
                                    <input
                                        id="billing_telephone"
                                        v-model="customer.billing_telephone"
                                        type="text"
                                        placeholder="Billing telephone"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.billing_telephone }"
                                    >
                                    <error
                                        name="billing_telephone"
                                        :errors="errors"
                                    />
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="responsible_person_name">Responsible person name:</label>
                                <input
                                    id="responsible_person_name"
                                    v-model="customer.responsible_person_name"
                                    type="text"
                                    placeholder="Responsible person name"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.responsible_person_name }"
                                >
                                <error
                                    name="responsible_person_name"
                                    :errors="errors"
                                />
                            </div>

                            <div class="row">
                                <div class="form-group col-sm-6">
                                    <label for="responsible_person_email">Responsible person email:</label>
                                    <input
                                        id="responsible_person_email"
                                        v-model="customer.responsible_person_email"
                                        type="email"
                                        placeholder="Billing email"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.responsible_person_email }"
                                    >
                                    <error
                                        name="responsible_person_email"
                                        :errors="errors"
                                    />
                                </div>
                                <div class="form-group col-sm-6">
                                    <label for="responsible_person_telephone">Responsible person telephone:</label>
                                    <input
                                        id="responsible_person_telephone"
                                        v-model="customer.responsible_person_telephone"
                                        type="text"
                                        placeholder="Responsible person telephone"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.responsible_person_telephone }"
                                    >
                                    <error
                                        name="billing_telephone"
                                        :errors="errors"
                                    />
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-sm-6">
                                    <label for="response_time_hours">Response Time (hours):</label>
                                    <input
                                        id="response_time_hours"
                                        v-model="customer.response_time_hours"
                                        type="number"
                                        placeholder="8"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.response_time_hours }"
                                        step="0.01"
                                        min="0"
                                    >
                                    <error
                                        name="response_time_hours"
                                        :errors="errors"
                                    />
                                </div>
                            </div>

                            <hr>

                            <div class="form-group">
                                <button
                                    type="submit"
                                    class="btn btn-primary"
                                >
                                    Save
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    @click="$router.go(-1)"
                                >
                                    Back
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <div class="card">
                        <div class="card-body">
                            <h4>Customer Billing Address</h4>
                            <address-form
                                :address="customer"
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <b-modal
            ref="createdModal"
            title="Saved"
            :ok-only="true"
            @ok="closeModal"
        >
            <p>Customer saved successfully</p>
        </b-modal>
    </div>
</template>

<script>
import CustomerService from "../../../services/CustomerService";
import AddressForm from "../AddressForm.vue";
import UsesErrors from "../../../mixins/UsesErrors";

export default {
    components: {
        AddressForm,
    },
    mixins: [
        UsesErrors,
    ],
    data: function () {
        return {
            customer: {
                address_line_1: "",
                address_line_2: "",
                address_line_3: "",
                town: "",
                region: "",
                country: "",
                postcode: "",
                w3w: "",
                billing_address_id: null,
                overdue: false,
                proforma: false,
                response_time_hours: 8,
            },
            customerService: CustomerService,
            autocomplete: null
        };
    },

    methods: {
        createCustomer: function () {
            this.clearErrors();
            this.customerService
                .create(this.customer)
                .then(xhr => {
                    this.customer = xhr.data;
                    this.$refs.createdModal.show();
                })
                .catch(error => {
                    this.captureRequestErrors(error);
                });
        },

        closeModal: function () {
            this.$router.push({name:'office.customers.show', params: {id: this.customer.id}});
        },
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/office/customers/CreateComponent.vue